import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
// import Axios from "axios";

loadFonts()
// Axios.defaults.baseURL = "http://192.168.20.173:8083";

createApp(App)
  .use(router)
  .use(vuetify)
  .mount('#app')
